import React from "react";
// @flow
import Badge from "react-bootstrap/lib/Badge";
import Icons from "@hs/icons";
import loc from "i18next";
import Mark from "@hs/mark";
import styles from "./FolderTree.module.css";
import { BrowserDragLink } from "components/ItemUriLink";
import { getClassNames } from "data/utils";
import withStickyToggle from "containers/StickyToggle";
import { isHandheld } from "data/bowser";

type Props = {
    /** callback when user expands a tree item
     * @param {TreeItemDTO} treeItem tree item's object the user clicked
     * @param {SyntheticMouseEvent<*>} e HTML event object
     */
    onExpand: (treeItem: TreeItemDTO, e: SyntheticMouseEvent<*>) => void,
    /** filter text currently applied */
    filter?: string,
    /** tree item's object */
    treeItem: TreeItemDTO,
    /** localized webdav name */
    localizedWebDavName: string,
};

const RowContent = ({
    onExpand,
    filter,
    treeItem,
    localizedWebDavName,
}: Props) => (
    <>
        <span
            className={styles.listLeft}
            onClick={/* istanbul ignore next */ (e) => onExpand(treeItem, e)}
        >
            {treeItem.numberOfChildren > 0 && (
                <Icons.Library
                    className={getClassNames(styles.expand)}
                    name="caret-right"
                />
            )}
            {treeItem.numberOfChildren === 0 && (
                <span className={styles.noexpand} />
            )}
            <BrowserDragLink itemUri={treeItem.itemUri + ""}>
                <Icons.Custom
                    elementType={treeItem.elementType}
                    icon={treeItem.icon}
                    color={treeItem.color}
                    className={getClassNames(styles.elementIcon, "fa-fw")}
                />
            </BrowserDragLink>
        </span>
        <Mark word={filter} className={styles.listName}>
            {localizedWebDavName}
        </Mark>
        {treeItem.numberOfChildren > 0 && (
            <Badge
                className={[styles.treeCount, "hidden-xs"].join(" ")}
                title={loc.format(treeItem.numberOfChildren, "pretty")}
            >
                {loc.format(treeItem.numberOfChildren, "pretty")}
            </Badge>
        )}
    </>
);

export const calculatePosition = (node) => {
    if (!node) return 0;

    const calclulatedPposition = (node.offsetHeight - 26) / 2;

    if (isHandheld()) return calclulatedPposition;

    return node.parentNode?.querySelector(".badge") ? 0 : calclulatedPposition;
};

const RowContentWithStickyToggle = withStickyToggle({
    renderDiv: true,
    usePortal: false,
    getStyle: /* istanbul ignore next*/ ({ node, isActive, isHovered }) => {
        const rgb = isActive
            ? "0,152,170"
            : isHovered
            ? "245,245,245"
            : "255,255,255";
        return {
            position: "absolute",
            zIndex: 99,
            bottom: calculatePosition(node),
            right: 0,
            color: isActive ? "white" : "inherit",
            background: `linear-gradient(90deg, rgba(${rgb},0) 0%, rgba(${rgb},1) 50%)`,
        };
    },
})(RowContent);

export default RowContentWithStickyToggle;
